import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { enableLoadingOverlay, endLoadingOverlay } from '../actions'

/**
 * Custom hook to wrap an Apollo mutation with a loading overlay
 * @param {Function} mutate - The mutate function returned by Apollo useMutation
 * @returns {Function} mutateAndLoading - A wrapped mutate function that handles loading overlay
 */
export function useMutateAndLoading(mutate) {
  const dispatch = useDispatch()

  const mutateAndLoading = useCallback(
    async (operation, ...args) => {
      const key = new Date().getTime()

      // Display loading overlay
      dispatch(enableLoadingOverlay(key, operation))

      try {
        // Execute the actual mutation
        const res = await mutate(...args)

        // Hide loading overlay on success
        dispatch(endLoadingOverlay(key, operation))

        return res.data
      } catch (error) {
        // Hide loading overlay and mark error on failure
        dispatch(endLoadingOverlay(key, operation, { error: true }))
        throw error
      }
    },
    [mutate, dispatch]
  )

  return mutateAndLoading
}
